/**
 * Date validation utilities for blocking weekends and public holidays in date pickers.
 * Public holidays come from the backend (usePublicHolidays hook → GET /api/System/public-holidays)
 * so date pickers and backend rules (e.g. sick leave evidence) use the same source (Nager.Date).
 */

/** Saturday = 6, Sunday = 0 */
export function isWeekend(date: Date): boolean {
  const day = date.getDay();
  return day === 0 || day === 6;
}

/**
 * Returns true if the date should be disabled (weekend or public holiday).
 * When isHoliday is provided (e.g. from usePublicHolidays), uses backend holiday data; otherwise weekends only.
 */
export function shouldDisableDate(
  date: Date,
  isHoliday?: ((d: Date) => boolean) | null
): boolean {
  if (isWeekend(date)) return true;
  if (isHoliday && isHoliday(date)) return true;
  return false;
}

/**
 * Creates a shouldDisableDate callback for MUI DatePicker.
 * Pass the country from useDateLocale and isHoliday from usePublicHolidays so holidays match the backend.
 */
export function createShouldDisableDate(
  isHoliday?: ((d: Date) => boolean) | null
): (date: Date) => boolean {
  return (date: Date) => shouldDisableDate(date, isHoliday);
}
